import { merge } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { bigQuery } from '@fiverr-private/obs';
import { BQ_CONSTS } from './constants';

const extractBaseStoreParams = (store) => ({
    sharingId: store.assetsSharing?.id,
    sharingType: store.assetsSharing?.sharingType,
    sellerId: store.assetsSharing?.sellerId,
    gigId: store.assetsSharing?.gigId,
});

const extractStoreParams = (store, params) => {
    let storeParams = {};

    if (params.resourceId) {
        const foundAsset = store.assetsSharing?.assets?.find(({ resourceId }) => resourceId === params.resourceId);

        if (foundAsset) {
            const { resourceId, resourceType, src, type } = foundAsset;
            storeParams = {
                ...storeParams,
                resourceId,
                resourceType,
                resourceUrl: src,
                fileType: type,
            };
        }
    }

    return storeParams;
};

const baseBQEventData = (storeContext) => {
    const { isTouch, userId, userGuid, pageCtxId } = getContext();
    const {
        CLIENT_ENTITY,
        PLATFORMS: { WEB, MOBILE_WEB },
        DOMAIN,
        SUB_DOMAIN,
        PAGE: { NAME },
    } = BQ_CONSTS;
    const { sharingId, sharingType, sellerId, gigId } = storeContext;

    return {
        user: {
            id: userId,
        },
        uid: userGuid,
        entity: CLIENT_ENTITY,
        platform: isTouch ? MOBILE_WEB : WEB,
        out_of_session: false,
        domain: {
            name: DOMAIN,
        },
        publisher: {
            domain: DOMAIN,
            sub_domain: SUB_DOMAIN,
        },
        page: {
            name: NAME,
            ctx_id: pageCtxId,
        },
        assets_sharing: {
            id: sharingId,
            type: sharingType,
        },
        seller: {
            id: sellerId,
        },
        gig: {
            id: gigId,
        },
        created_at: new Date(),
    };
};

const reportBQEvent = (type, enrichFunc, store, params) => {
    bigQuery.send(
        merge(
            {},
            baseBQEventData(extractBaseStoreParams(store)),
            enrichFunc({
                ...params,
                ...extractStoreParams(store, params),
            }),
            { type }
        )
    );
};

export const reportFunc =
    (type, enrichFunc) =>
    (store, params = {}) => {
        reportBQEvent(type, enrichFunc, store, params);
    };
